import shiftRequestDetailsStore from "../../store/store";
import { IMemberEntity } from "sh-models";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_SENDER_MEMBER', function setSenderMemberInStore(member: IMemberEntity) {
    if (shiftRequestDetailsStore) {
        shiftRequestDetailsStore.senderMember = member;
    }
});
